module.exports = __webpack_public_path__ + "static/media/AU.b35a142d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/AU.svg
// module id = 2103
// module chunks = 7